import { Table } from "../../../components/Table";
import { useCustomers } from "../../../store/Customer";
import { CreateCustomerInput, Customer } from "../../../api/schema";
import { UserLanguage } from "../../../lang/lang";
import {
  FlexCenter,
  FlexGrow,
  FlexRowStretch,
} from "../../../components/flex/Flex";
import { Button } from "@blueprintjs/core";
import { useState } from "react";
import {
  DeleteModal,
  DeleteStateHelper,
} from "../../../components/form/DeleteModal";
import { useMutation } from "@apollo/client";
import { ValuesVariables } from "../../../components/form/InputForm";
import {
  CreateCustomerResponse,
  CustomerMutations,
  DeleteCustomerResponse,
} from "../graphql";
import { CreateCustomerModal } from "../Modals";
import { CustomerTableColoumns } from "./table";

interface CustomerListViewProps {}

export const CustomerListView = (props: CustomerListViewProps) => {
  const [customer_store, refetch] = useCustomers();

  const [create_modal_open, set_create_modal_open] = useState(false);

  const [delete_modal_state, set_delete_modal_state] =
    useState<DeleteStateHelper>({
      open: false,
      id: undefined,
      prettyPrint: undefined,
    });

  const [create_customer] = useMutation<
    CreateCustomerResponse,
    ValuesVariables<CreateCustomerInput>
  >(CustomerMutations.create);

  const [delete_customer] = useMutation<DeleteCustomerResponse>(
    CustomerMutations.delete
  );

  const on_delete = (item?: Customer) =>
    set_delete_modal_state(
      item
        ? {
            open: true,
            id: item.id,
            prettyPrint: `${UserLanguage().data.name}: ${item.name}`,
          }
        : {
            open: false,
            id: undefined,
            prettyPrint: "",
          }
    );

  return (
    <FlexCenter style={{ padding: "2em" }}>
      <div style={{ width: "100%" }}>
        <FlexRowStretch>
          <div>
            <h2>{UserLanguage().pages.customer.list.label}</h2>
          </div>
          <FlexGrow />
          <div>
            <Button
              intent="success"
              icon="plus"
              onClick={() => set_create_modal_open(true)}
            >
              {UserLanguage().actions.create}
            </Button>
          </div>
        </FlexRowStretch>
        <CreateCustomerModal
          bundle={{
            open: create_modal_open,
            onClose: () => set_create_modal_open(false),
            mutation: create_customer,
            onSuccess: refetch,
          }}
        />
        <DeleteModal<DeleteCustomerResponse>
          id={delete_modal_state.id}
          open={delete_modal_state.open}
          mutation={(id) => delete_customer({ variables: { id } })}
          texts={UserLanguage().pages.customer.actions}
          resetOnClose
          onClose={() => on_delete()}
          onSuccess={() => {
            on_delete();
            refetch();
          }}
          type={UserLanguage().data.customer.label}
          prettyPrint={delete_modal_state.prettyPrint}
        />
        <Table<Customer>
          loading={customer_store.loading}
          columns={CustomerTableColoumns({ on_delete, on_edit: () => {} })}
          items={customer_store.customers}
        />
      </div>
    </FlexCenter>
  );
};
